module.exports = __webpack_public_path__ + "img/1-19.c0ce9b2d.png";